import { BffApiClient } from '@/common/services/api/bffClient';
import { searchEndpoints } from '@/features/search/endpoints/searchEndpoints';
import { SearchResult } from '../types';
import { logger } from '@/common/services/config';
import { GlobalMockupService } from '@/common/services/mockup';
import { fakeResults } from '../fake-data/fakeResults';

export class SearchService {
  private static api = BffApiClient.getInstance();

  /**
   * Get users by role type and by name
   * @param roleType The role type to filter users by
   * @param name The name to search for
   */
  static async getSearches(roleType: string, name: string): Promise<SearchResult[]> {
    try {
      if (GlobalMockupService.isFeatureMockupEnabled('search')) {
        logger.log('Using mockup data for search results');
        return fakeResults;
      }
      const response = await this.api.get(searchEndpoints.searchByRoleTypeByName(roleType, name));
      return response.data as SearchResult[];
    } catch (error) {
      logger.error('Error fetching search results:', error);
      throw error;
    }
  }
}
